import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db, hasConfig } from './firebaseconfig';

const SignupPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!hasConfig || !auth || !db) {
    return (
      <div className="san-diego-alarm-program">
        <div className="sd-login-box">
          <p className="rhs-error">Account signup is unavailable — Firebase is not configured.</p>
          <Link to="/">Back to login</Link>
        </div>
      </div>
    );
  }

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const cred = await createUserWithEmailAndPassword(auth, email, password);
      await setDoc(doc(db, 'users', cred.user.uid), {
        email,
        role: 'user',
        createdAt: new Date().toISOString(),
      });
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="san-diego-alarm-program">
      <div className="sd-login-box">
        <p className="rhs-login-brand">RobinhoodSpace</p>
        <h2>Create account</h2>
        <form onSubmit={handleSignup}>
          <div className="sd-form-row">
            <label htmlFor="signup-email">Email</label>
            <input
              id="signup-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="sd-form-row">
            <label htmlFor="signup-password">Password</label>
            <input
              id="signup-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>
          {error && <p className="rhs-error">{error}</p>}
          <button type="submit" className="sd-login-button" disabled={loading}>
            {loading ? 'Creating…' : 'Sign up'}
          </button>
        </form>
        <p style={{ marginTop: '1rem' }}>
          <Link to="/">Back to login</Link>
        </p>
      </div>
    </div>
  );
};

export default SignupPage;
